const API_KEY = 'eb3951110f37c8ee30f5e146dc484168';
const BASE_URL_API = 'https://api.themoviedb.org/3';
const BASE_URL_IMG = 'https://image.tmdb.org/t/p/';
const FILE_SIZE = 'w500';
const ALL_GENRES_KEY_LS = 'all-movie-genres';
const WEB_LOCAL_WATCHED = 'watched-list-movie';
const WEB_LOCAL_QUEUE = 'queue-list-movie';
const LIST_WATCHED = 'watched';
const LIST_QUEUE = 'queue';

export {
  API_KEY,
  BASE_URL_API,
  BASE_URL_IMG,
  FILE_SIZE,
  ALL_GENRES_KEY_LS,
  WEB_LOCAL_WATCHED,
  WEB_LOCAL_QUEUE,
  LIST_WATCHED,
  LIST_QUEUE,
};
